import { Component, Input } from '@angular/core';
import { Coluna, DepreciacaoImovelItem, FormatoExportacao, FuncaoService, Imovel, Login, Relatorio } from 'eddydata-lib';

@Component({
  selector: 'app-bem-imovel-depreciacao',
  templateUrl: './bem-imovel-depreciacao.component.html'
})
export class BemImovelDepreciacaoComponent {

  @Input() public login: Login;
  @Input() public entidade: Imovel;
  @Input() public depreciacoes: DepreciacaoImovelItem[];
  public itemAtual: DepreciacaoImovelItem;

  constructor(
    public funcaoService: FuncaoService) {
  }

  public exportarListagem(formato: FormatoExportacao) {
    if (formato === 'pdf') {
      Relatorio.imprimir(`Depreciacoes do bem ${this.entidade.placa}`, this.login.usuario.nome, this.login.usuario.sobrenome, this.login.orgao.nome, this.login.brasao,
        this.depreciacoes, this.colunas(), 'portrait', `Depreciacoes do bem ${this.entidade.placa}`,
        ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto']);
    } else {
      this.funcaoService.exportar(formato, this.depreciacoes, `Depreciacoes do bem ${this.entidade.placa}`, this.colunas());
    }
  }

  private colunas(): Coluna[] {
    return [
      { titulo: 'Data', coluna: 'depreciacao.data_cadastro', alignment: 'center' },
      { titulo: 'Usuario', coluna: 'depreciacao.usuario.nome' },
      { titulo: 'Ano', coluna: 'depreciacao.ano', alignment: 'center' },
      { titulo: 'Mes', coluna: 'depreciacao.mes', alignment: 'center' },
      { titulo: 'Qtd Acumulada', coluna: 'qtde_depreciada_acumulada', alignment: 'right' },
      { titulo: 'Valor Depreciado', coluna: 'valor_depreciado', alignment: 'right', decimais: 3 },
      { titulo: 'Depr. Anterior', coluna: 'valor_depreciado_anterior', alignment: 'right', decimais: 3 },
      {
        titulo: 'Depr. Atual', coluna: 'valor_depreciado_atual', alignment: 'right', decimais: 3, funcao: [{
          valor: ['valor_depreciado_anterior', '+', 'valor_depreciado']
        }]
      },
      { titulo: 'Valor Anterior', coluna: 'valor_tombo_anterior', alignment: 'right' },
      {
        titulo: 'Valor Atual', coluna: 'valor_atual', alignment: 'right', funcao: [{
          valor: ['valor_tombo_anterior', '-', 'valor_depreciado']
        }]
      },
    ];
  }

  public exibirSeparadorCiclo(index: number): boolean {
    const item = this.depreciacoes?.[index];
    const proximoItem = this.depreciacoes?.[index + 1];

    return +item?.qtde_depreciada_acumulada === 1 && !!proximoItem;
  }
}
